var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"500px"}},[_c('LoadingModal',{attrs:{"show":true,"sucesso":false,"texto":"Enviando a solicitação. Por favor aguarde…"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }